import axios from 'axios'
import {UserModel} from './_models'
import {ipstackDefaultData} from './_constants'

const API_URL = process.env.REACT_APP_BASE_API_URL
const IPSTACK_URL = `${process.env.REACT_APP_IPSTACK_LINK}?access_key=${process.env.REACT_APP_IPSTACK_ACCESS_KEY}&format=1`
const COUNTRY_URL = `${API_URL}/country`

export const INVITE_USER = `${API_URL}/auth/invite`
export const ACCEPT_INVITATION = `${API_URL}/auth/accept-invite`
export const CREATE_COMPANY = `${API_URL}/company`
export const CREATE_ROUND = `${API_URL}/round`
export const CURRENCIES = `${API_URL}/currency`
export const STATE = ``
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/verify-token`
export const GET_FILE_URL = `${API_URL}/file`
export const GET_USER_TOKEN = `${API_URL}/user/token`
export const UPDATE_ROUND = `${API_URL}/round`
export const MODULE_STATUS_API = `${API_URL}/modules-status`
export const EXPRESS_ONBOARDING_API = `${API_URL}/express-onboarding`
export const SEND_OTP = `${API_URL}/auth/phone-verification-send-otp`
export const VERIFY_OTP = `${API_URL}/auth/phone-verification-verify-otp`

// export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

//invite user
type InviteUser = {
  firstName: string
  lastName: string
  email: string
  designation: string
}

export function inviteUser(companyId: string, Users: InviteUser[]) {
  return axios.post(
    INVITE_USER,
    {companyId, Users},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

//accept invitation
export function acceptInvitation(inviteToken: string, password: string) {
  return axios.post(ACCEPT_INVITATION, {inviteToken, password})
}

//create company
export function createCompany(
  companyName: string,
  country: string,
  state: string,
  city:string,
  zipCode:number,
  logoId: number|undefined,
  chargebeePlanId: string,
  inviteCode?: string,
  useCase?: string,
  forClientUse?: boolean,
  teamSize?: number,
  industry?: string,
  heardAboutUs?: string,
  isNotExistingUser?: boolean
) {
  return axios.post(
    CREATE_COMPANY,
    {
      name: companyName,
      countryId: Number(country),
      stateId: Number(state),
      city,
      zipCode,
      logoId,
      chargebeePlanId,
      inviteCode,
      useCase,
      forClientUse,
      teamSize,
      industry,
      heardAboutUs,
      isNotExistingUser,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

//create round
export function createRound(
  roundName: string,
  roundType: string,
  amountTargeted: number,
  amountAchieved: number,
  currency: string,
  companyId: number
) {
  const currencyId = parseInt(currency)

  return axios.post(
    CREATE_ROUND,
    {
      roundName,
      roundType,
      amountTargeted,
      amountAchieved,
      currencyId,
      companyId,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

//module status
export function fetchModuleStatuses() {
  return axios.get(MODULE_STATUS_API)
}

//currencies
export function currencies() {
  return axios.get(CURRENCIES)
}

export function state(countryId: string) {
  return axios.get(`${API_URL}/state/${countryId}`)
}
export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    token: token,
  })
}

/**
 * Fetch location data from IPStack
 * If the call fails, return an object structured like an Axios response:
 * {
 *   data: { ... }
 * }
 * This way, the destructuring in the caller remains the same.
 */
export const getLocation = async () => {
  try {
    const response = await axios.get(IPSTACK_URL)
    
    if (!(response.data)) {
      throw new Error('IPStack API request failed') // Explicitly throw an error
    }
    return response // This is an Axios response object, which has a `data` property.
  } catch (error) {
    // console.error('Error fetching location data:', error)
    // Return a mock Axios response structure with `data` as nycDefaultData
    return {data: ipstackDefaultData}
  }
}
// getCountry
export const getCountry = () => {
  return axios.get(COUNTRY_URL)
}

//getUserToken
export const getUserToken = () => {
  return axios.get(GET_USER_TOKEN)
}
//updateround
export const updateRound = (
  roundName: string,
  roundType: string,
  amountTargeted: number,
  amountAchieved: number,
  currency: string,
  companyId: number,
  roundId: number
) => {
  const currencyId = parseInt(currency)

  return axios.put(
    UPDATE_ROUND + `/${roundId}`,
    {
      roundName,
      roundType,
      amountTargeted,
      amountAchieved,
      currencyId,
      companyId,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export function createExpressOnboarding(
  countryId: number,
  stateId: number,
  city:string,
  zip:number,
  planName: string,
  inviteCode?: string,
  useCase?: string,
  forClientUse?: boolean,
  teamSize?: number,
  industry?: string,
  heardAboutUs?: string,
  
) {
  return axios.post(
    EXPRESS_ONBOARDING_API,
    {
      countryId,
      stateId,
      city,
      zip,
      planName,
      inviteCode,
      useCase,
      forClientUse,
      teamSize,
      industry,
      heardAboutUs,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export function createOtp(companyId: number, payload: any) {
  return axios.post(SEND_OTP, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export function verifyPhoneOtp(companyId: number, payload: any) {
  return axios.post(VERIFY_OTP, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}
